<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <navbar :title="$t('delivery_note.title')"/>
        <div class="col-sm-12 nopads">
      <div
        class="nopads pb-1 my-1"
      >
        <div
          v-if="!selectedStation"
          class="search-form pb-3 mt-2"
        >
          <div class="row px-2">
            <div class="col-sm-5">
              <h5>{{ $t('delivery_note.station') }}</h5>
                <select
                    v-model="station"
                    class="form-select form-select-sm"
                    @change="selectStation"
                >
                    <option :value="null">
                        {{ $t('delivery_note.form.select_station') }}
                    </option>
                    <option
                        v-for="station in stations"
                        :key="station.id"
                        :value="station.id"
                    >
                        {{ station.name }}
                    </option>
                </select>
            </div>
          </div>
        </div>
        <div
          v-else
          class="col-sm-6 pl-3 ml-1 pb-0"
        >
          <h3>{{ selectedStation.name }}</h3>
        </div>
      </div>
      <!-- Editor for adding new notes -->
      <delivery-note-editor
          v-if="station"
          ref="newNoteEditor"
          class="my-1"
          :note="deliveryNote"
          :station="station"
          :contracts="editorContracts"
          :show-only-my-contracts-option="true"
          :materials="materials"
          @only-user-owned-contract-selected="onlyUserOwnedContractSet"
          @update="update"
          @close="closeEdit"
      />
      <delivery-note-search
          v-if="station"
          class="my-2"
          ref="noteSearch"
          :show-only-my-contracts-option="true"
          :station="station"
          :contracts="searchContracts"
          :materials="materials"
          :login-time="loginTime"
          @search="fetchDeliveryNotes"
          @only-user-owned-contract-selected="onlyUserOwnedContractSet"
      />
      <Transition name="fade">
        <material-status-summary
            v-if="notes && notes.length > 0"
            :deliveries="notes"/>
      </Transition>
      <delivery-note-list
        v-if="station"
        class="my-1"
        :notes="notes"
        :station="station"
        :is-observer="isObserver"
        @edit="editNote"
      />
    </div>
        <!-- Editor for editing existing notes -->
    <base-modal v-if="editMode" hide-header hide-footer @close="closeEdit" size="lg">
        <delivery-note-editor
            class="my-1"
            :note="selectedDeliveryNote"
            :station="station"
            :contracts="editorContracts"
            :show-only-my-contracts-option="true"
            :materials="materials"
            @only-user-owned-contract-selected="onlyUserOwnedContractSet"
            @update="update"
            @close="closeEdit"
        />
    </base-modal>
    <div
      v-if="!!loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from "@/components/mixins/TimeUtils";
import {deliveryNoteHelper} from "@/components/mixins/DeliveryNoteMixin";
import DeliveryNoteEditor from "@/components/materials/DeliveryNoteEditor";
import DeliveryNoteList from "@/components/materials/DeliveryNoteList";
import DeliveryNoteSearch from "@/components/materials/DeliveryNoteSearch";
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";
import MaterialStatusSummary from "./MaterialStatusSummary.vue";

export default {
    name: "MaterialDeliveryNotes",
    components: {MaterialStatusSummary, BaseModal, Navbar, DeliveryNoteSearch, DeliveryNoteList, DeliveryNoteEditor},
    mixins: [restApi, deliveryNoteHelper, timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        },
        isObserver: {
            type: Boolean,
            default: false
        },
        selectedStation: {
            type: Object,
            default: null
        },
        loginTime: {
            type: Date,
            default: null
        },
    },
    data() {
        return {
            notes: [],
            stations: [],
            editorContracts: [],
            searchContracts: [],
            materials: [],
            station: null,
            deliveryNote: null,
            editMode: false,
            lastSearchParams: null,
            loading: 0,
            selectedDeliveryNote: null,
            onlyUserOwnedContracts: false
        }
    },
    created: function () {
        this.fetchMaterialStations()
        this.deliveryNote = this.newDeliveryNote()
    },
    methods: {
        fetchDeliveryNotes: function (params) {
            this.loading++
            if (!params) {
                params = {}
            } else {
                this.lastSearchParams = params
            }
            if (this.selectedStation) {
                params.station = this.selectedStation.id
            } else {
                params.station = this.station
            }
            this.restFetchParams(this.materialDeliveryUrl, this.lastSearchParams, this.fetchNotesSuccess, this.fetchFail)
        },
        fetchMaterialStations: function () {
            this.loading++
            this.restFetch(this.materialStationUrl, this.fetchStationsSuccess, this.fetchFail)
        },
        fetchContracts: function (type=null) {
            this.loading++
            let params = {}
            if (this.station) {
                let station = this.stations.find(x => x.id === this.station)
                if (station) {
                    params.contractor = station.company.id
                }
            }
            if(this.onlyUserOwnedContracts === true) {
                params.onlyUserOwnedContracts = 1
            }
            params.startDate = this.getStartOfTheDay(new Date())
            params.endDate = this.getEndOfTheDay(new Date())
            if(type=="search") {
                this.restFetchParams(this.contractOpenUrl, params, this.searchContractsSuccess, this.fetchFail)
            } else if(type=="editor") {
                this.restFetchParams(this.contractOpenUrl, params, this.editorContractsSuccess, this.fetchFail)
            } else {
                this.restFetchParams(this.contractOpenUrl, params, this.contractsSuccess, this.fetchFail)
            }
        },
        selectStation: function () {
            if (this.selectedStation) {
                this.station = this.selectedStation.id
            }
            this.getMaterials()
            this.fetchContracts()
        },
        getMaterials: function () {
            this.materials = []
            if (this.stations && this.station === null) {
                this.stations.forEach(station => {
                    if (station.station_materials) {
                        station.station_materials.forEach(material => {
                            this.materials.push(material)
                        })
                    }
                })
            } else {
                let station = this.stations.find(x => x.id === this.station)
                if (station) {
                    this.materials = station.station_materials
                }
            }
        },
        fetchNotesSuccess: function (response) {
            this.notes = response.data
            this.loading--
        },
        fetchStationsSuccess: function (response) {
            this.stations = response.data
            this.selectStation()
            this.loading--
        },
        contractsSuccess: function (response) {
            this.searchContracts = response.data
            this.editorContracts = response.data
            this.loading--
        },
        searchContractsSuccess: function (response) {
            this.searchContracts = response.data
            this.loading--
        },
        editorContractsSuccess: function (response) {
            this.editorContracts = response.data
            this.loading--
        },
        fetchFail: function () {
            this.loading--
        },
        update: function (newNote = false) {
            if (!newNote) {
                this.closeEdit()
            }
            if (this.lastSearchParams) {
                this.fetchDeliveryNotes(this.lastSearchParams)
            } else {
                this.$nextTick(() => this.$refs.noteSearch.refreshParams())
            }
            // Request also new note editor to update its vehicle list
            this.$refs.newNoteEditor?.updateVehicles()
        },
        closeEdit: function () {
            this.editMode = false
            this.selectedDeliveryNote = this.newDeliveryNote()
        },
        editNote: function (note) {
            this.selectedDeliveryNote = note
            this.editMode = true
            this.station = note.station_material ? note.station_material.station.id : undefined
            this.selectStation()
        },
        onlyUserOwnedContractSet: function(value, type) {
            this.onlyUserOwnedContracts = value
            this.fetchContracts(type)
        }
    }
}
</script>
